// user actions
export const SET_USER_AUTH_TOKEN = 'USER_SESSION:ACTION:SET_USER_AUTH_TOKEN';
export const SET_USER_LOGGED_IN = 'USER_SESSION:ACTION:SET_USER_LOGGED_IN';
export const SET_USER_LOGGED_OUT = 'USER_SESSION:ACTION:SET_USER_LOGGED_OUT';
export const SET_USER_NAME = 'USER_SESSION:ACTION:SET_USER_NAME';
// @TODO ACT-1412 Remove once code using this has been updated
export const SET_LOGGED_IN_DEPRECATED = 'LOGGED_IN';
// reg login actions
export const HIDE_REG_LOGIN_LIGHTBOX = 'USER_SESSION:ACTION:HIDE_REG_LOGIN_LIGHTBOX';
export const HIDE_GOOGLE_ONE_TAP = 'USER_SESSION:ACTION:HIDE_GOOGLE_ONE_TAP';
export const SET_REG_LOGIN_INPUT_VALUES = 'USER_SESSION:ACTION:SET_REG_LOGIN_INPUT_VALUES';
export const SET_REG_LOGIN_NODE = 'USER_SESSION:ACTION:SET_REG_LOGIN_NODE';
export const SET_REG_LOGIN_PATH = 'USER_SESSION:ACTION:SET_REG_LOGIN_PATH';
export const SET_PASSWORD_REQUIRED = 'USER_SESSION:ACTION:SET_PASSWORD_REQUIRED';
export const SET_RESET_PASSWORD_LINK_URL = 'USER_SESSION:ACTION:SET_RESET_PASSWORD_LINK_URL';
export const SET_REG_LOGIN_REDIRECT_URL = 'USER_SESSION:ACTION:SET_REG_LOGIN_REDIRECT_URL';
export const SET_REG_LOGIN_ZMA_HANDLERS = 'USER_SESSION:ACTION:SET_REG_LOGIN_ZMA_HANDLERS';
export const SET_REG_LOGIN_UI_CONFIG = 'USER_SESSION:ACTION:SET_REG_LOGIN_UI_CONFIG';
export const SET_REG_LOGIN_UI_CONFIG_DEFAULTS = 'USER_SESSION:ACTION:SET_REG_LOGIN_UI_CONFIG_DEFAULTS';
export const SHOW_REG_LOGIN_LIGHTBOX = 'USER_SESSION:ACTION:SHOW_REG_LOGIN_LIGHTBOX';
export const SHOW_GOOGLE_ONE_TAP = 'USER_SESSION:ACTION:SHOW_GOOGLE_ONE_TAP';
// Onboarding questionnaire actions
export const SHOW_ONBOARDING_QUESTIONNAIRE = 'USER_SESSION:ACTION:SHOW_ONBOARDING_QUESTIONNAIRE';
export const HIDE_ONBOARDING_QUESTIONNAIRE = 'USER_SESSION:ACTION:HIDE_ONBOARDING_QUESTIONNAIRE';
export const SET_ONBOARDING_CONFIG = 'USER_SESSION:ACTION:SET_ONBOARDING_CONFIG';
